//
//
//
//
//
//
//
//
//
//


export default {
  name: 'PointsIcon',
  props: {
    active: {
      type: Boolean,
      default: true,
    },
  },
};

